import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Event, NavigationStart, NavigationError } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'GRT BRANDING MONITORING';
  isLogin = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
          this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                //do something on start activity
                console.log("AppComponent start " + event);
                if(event.url == "/login") {
                  this.isLogin = true;
                } else {
                  this.isLogin = false;
                }
            }
            if (event instanceof NavigationError) {
                console.error(event.error);
            }
            if (event instanceof NavigationEnd) {
            }
        });
   }

  ngOnInit() {

  }


}

